import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function Courses() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    CommonService.getAllCourses().then((data) => setCourses(data));
  }, []);

  return (
    <fieldset>
      <legend>{t("Course")}</legend>{" "}
      <select
        name="courseId"
        className="form-select"
        onChange={onChange}
        value={searchObject.courseId || ""}
      >
        <option value=""></option>
        {courses.map((course) => (
          <option key={course.id} value={course.description}>
            {t(course.description)}
          </option>
        ))}
      </select>
    </fieldset>
  );
}
